import { Link } from 'react-router-dom';
import { useProducts } from '../../context/ProductContext';

export default function AdminDashboard() {
  const { products, isLoading } = useProducts();

  const inStock = products.filter((p) => p.inStock).length;
  const outOfStock = products.length - inStock;

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Dashboard</h1>
        <div className="admin-actions">
          <Link to="/admin/orders" className="btn btn-outline">
            Siparişler
          </Link>
          <Link to="/admin/products/new" className="btn btn-primary">
            + Yeni Ürün
          </Link>
        </div>
      </div>

      {isLoading ? (
        <p>Yükleniyor...</p>
      ) : (
        <div className="admin-stats">
          <div className="admin-stat-card">
            <span>Toplam Ürün</span>
            <strong>{products.length}</strong>
          </div>
          <div className="admin-stat-card">
            <span>Stokta</span>
            <strong>{inStock}</strong>
          </div>
          <div className="admin-stat-card">
            <span>Stokta Yok</span>
            <strong>{outOfStock}</strong>
          </div>
        </div>
      )}
    </div>
  );
}
